export class Sheet {
  grade: number = 0
  name: string = ""
  curriculum_id: number = 0
  subject_name: string = ""
  sheet_type: number

  constructor(sheet: any){
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.sheet_type = sheet.sheet_type;
  }
}

export class ScoreRateHeaderItem {
  room_name: string
  count: number

  constructor(room_name: string, count: number){
    this.room_name = room_name == "全体" ? room_name : `${room_name}組`;
    this.count = count;
  }
}

export class ScoreRateItem {
  room_name: string
  score_rate: number

  constructor(room_name: string, score_rate: number){
    this.room_name = room_name;
    this.score_rate = score_rate;
  }
}

export class ScoreRateRoomItem {
  room_name: string
  count: number
  per: number

  constructor(room_name: string, perFrom: number, perTo: number, scoreRateItems: ScoreRateItem[]){
    this.room_name = room_name;
    this.count = scoreRateItems.filter(x => x.score_rate >= perFrom && x.score_rate <= perTo).length;
    this.per = Math.round(this.count / scoreRateItems.length * 1000) / 10;
  }
}

export class ScoreRateRowItem {
  thColumn: string
  tdColumns: any[] = new Array<any>();

  constructor(rateFrom: number, rateTo: number, scoreRateRoomItems: ScoreRateRoomItem[]){
    this.thColumn =`${rateFrom}〜${rateTo}％`;
    scoreRateRoomItems.forEach(x => {
      this.tdColumns.push(`${x.per}％`);
      this.tdColumns.push(`${x.count}人`);
      this.tdColumns.push(x.per);
    });
  }
}